import { IConfig } from '@cian/config/shared';
import { createSelector } from '@reduxjs/toolkit';
import { selectFlatShare } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Не показывать', value: 2 },
  { label: 'Только доли', value: 1 },
];

export const selectFlatShareFilter = (config: IConfig) =>
  createSelector(selectFlatShare, value => ({
    label: 'Доли',
    value: [value],
    options: OPTIONS,
    visible: Boolean(config.get<boolean>('frontend_search_flat_share_enabled.Enabled')),
  }));
